import { Component, EventEmitter, OnInit, Input, Output } from "@angular/core";
import { ResizeEvent } from "angular-resizable-element";
import { CdkDrag, CdkDragHandle } from "@angular/cdk/drag-drop";

@Component({
  selector: "drawer",
  templateUrl: "./drawer.component.html",
})
export class DrawerComponent implements OnInit {

  @Input() public title: string;
  @Input() public saveLabel: string = "Save";
  @Input() public cancelLabel: string = "Cancel";
  @Input() public isClosed: boolean = true;
  @Input() public showHeaderButtons: boolean = true;
  @Input() public hideSave: boolean = false;
  @Input() public hideCancel: boolean = true;
  @Input() public hideDelete: boolean = true;
  @Input() public noContentPadding: boolean = false;
  @Input() public embedded: boolean = false;
  @Input() public forcePadding: boolean = false;
  @Input() public showHeader: boolean = true;
  @Input() public loading: boolean = false;
  @Input() public saveWithConfirmation: boolean = false;
  @Input() public saveWithConfirmationLabel: string = "Save";
  @Input() public saveWithConfirmationQuestion: string = "Are you sure?";
  @Input() public saveWithConfirmationClasses: string = "btn btn-primary";
  @Input() public contextLabel?: string;
  @Input() public contextLabelTooltip?: string;
  @Input() public contextVariant: "info" | "neutral" | "success" | "warning" | "danger" = "info";
  @Output() public closeEvent = new EventEmitter();
  @Output() public saveEvent = new EventEmitter();
  @Output() public saveWithConfirmationEvent = new EventEmitter();
  @Output() public cancelEvent = new EventEmitter();
  @Output() public deleteEvent = new EventEmitter();

  @Input() public showToggle: boolean = false;
  @Input() public toggleLabel: string = '';
  @Input() public toggleValue: boolean = false;
  @Output() public toggleChange = new EventEmitter<boolean>();
  @Output() public scrollEvent = new EventEmitter<void>();

  public onContentScroll(): void {
    this.scrollEvent.emit();
  }

  public resizeEdges = { bottom: false, right: false, top: false, left: this.embedded ? false : true };
  public style: object = {};
  public position: string = localStorage.getItem("drawer-position") || "right";

  public close() {
    // this.isClosed = !this.isClosed;
    this.closeEvent.emit(true);
  }

  public saveRequest() {
    this.saveEvent.emit(true);
  }

  public saveWithConfirmationRequest() {
    this.saveWithConfirmationEvent.emit(true);
  }

  public cancelRequest() {
    this.cancelEvent.emit(true);
  }

  public deleteRequest() {
    this.deleteEvent.emit(true);
  }

  public onToggleChange(value: boolean) {
    this.toggleChange.emit(value);
  }

  public changePosition(position: string) {
    this.style = {};
    this.position = position;
    localStorage.setItem("drawer-position", position);
    switch (position) {
      case "top":
        this.resizeEdges = { bottom: true, right: false, top: false, left: false };
        break;
      case "right":
        this.resizeEdges = { bottom: false, right: false, top: false, left: true };
        break;
      case "bottom":
        this.resizeEdges = { bottom: false, right: false, top: true, left: false };
        break;
      case "left":
        this.resizeEdges = { bottom: false, right: true, top: false, left: false };
        break;
      case "flying":
        this.resizeEdges = { bottom: true, right: false, top: false, left: true };
        break;
    }
    document.querySelectorAll(".position-popover").forEach((el) => {
      el.remove();
    });
  }

  public onResizeEnd(event: ResizeEvent) {
    if (this.position === "right" || this.position === "left") {
      this.style = {
        width: `${event.rectangle.width}px`,
      };
    }
    if (this.position === "top" || this.position === "bottom") {
      this.style = {
        height: `${event.rectangle.height}px`,
      };
    }
    if (this.position === "flying") {
      this.style = {
        height: `${event.rectangle.height}px`,
        width: `${event.rectangle.width}px`,
      };
    }
  }

  public async ngOnInit() {
    this.changePosition(this.position);
  }

}
